import { useScreenWidth } from "@msys/ui";
import { NavigateBefore as NavigateBeforeIcon } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { Link, To } from "react-router-dom";

/**
 * Responsive "Back" button: a compact icon on mobile, a text button on
 * tablet+. Acts as a plain button (`onClick`) or a link (`to`, open-in-new-tab).
 */
export const BackButton = ({
  onClick,
  to,
}: {
  onClick?: () => void;
  to?: To;
}) => {
  const { t } = useTranslate(["Global"]);
  const { isMinTablet } = useScreenWidth();

  const interactionProps = to ? { component: Link, to } : { onClick };

  const label = t("Back", { ns: "Global" });

  return !isMinTablet ? (
    <IconButton
      size="small"
      color="primary"
      aria-label={label}
      {...interactionProps}
    >
      <NavigateBeforeIcon />
    </IconButton>
  ) : (
    <Button
      size="extra-small"
      variant="text"
      color="primary"
      startIcon={<NavigateBeforeIcon />}
      {...interactionProps}
    >
      {label}
    </Button>
  );
};
